export default __webpack_public_path__ + "img/bCdNBBGW.72a67024.svg";